/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, QueryParams, SendRequestPayload } from '../baseClient';
import { 
  CoreOAuthGetInfoParams,
  OAuthRequestModel,
  OAuthInfoResponse,
  GenerateRedirectResponse
 } from '../types';

  //  CoreOAuthClient
class CoreOAuthClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly getInfo = (queryParams: CoreOAuthGetInfoParams): AxiosPromise<OAuthInfoResponse> => {
        let url_ = "/api/v1/core/oauth/info";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly generateRedirect = (payload: OAuthRequestModel): AxiosPromise<GenerateRedirectResponse> => {
        let url_ = "/api/v1/core/oauth/generate_redirect";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CoreOAuthClient
  
export const coreOAuthClient = new CoreOAuthClient(baseClientConstructorProps);
